import { useState } from 'react';
import { Mail, MessageCircle, MapPin, Send } from 'lucide-react';

const WHATSAPP_NUMBER = '917094127906'; // +91 70941 27906
const EMAIL = 'priyamuthukumar1203@gmail.com';

export default function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Portfolio Contact from ${formData.name}`);
    const body = encodeURIComponent(
      `${formData.message}\n\n— ${formData.name} (${formData.email})`
    );
    window.location.href = `mailto:${EMAIL}?subject=${subject}&body=${body}`;
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <section id="contact" className="py-24 px-6 lg:px-8 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-display font-bold text-4xl sm:text-5xl text-slate-900 mb-4">
          Get In Touch
        </h2>
        <p className="text-slate-500 text-lg max-w-2xl mb-14">
          Open to full-time roles — feel free to reach out directly or send a message below.
        </p>

        <div className="grid lg:grid-cols-5 gap-10">
          {/* Quick contact */}
          <div className="lg:col-span-2 space-y-4">
            <a
              href={`mailto:${EMAIL}`}
              className="flex items-center gap-4 p-5 rounded-2xl border border-slate-200 hover:border-violet-300 hover:shadow-md transition-all group"
            >
              <div className="w-11 h-11 rounded-xl bg-violet-50 text-violet-600 flex items-center justify-center flex-shrink-0 group-hover:bg-violet-100 transition-colors">
                <Mail size={20} />
              </div>
              <div className="min-w-0">
                <p className="text-sm text-slate-400">Email</p>
                <p className="font-medium text-slate-800 truncate">{EMAIL}</p>
              </div>
            </a>

            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 p-5 rounded-2xl border border-slate-200 hover:border-emerald-300 hover:shadow-md transition-all group"
            >
              <div className="w-11 h-11 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-100 transition-colors">
                <MessageCircle size={20} />
              </div>
              <div>
                <p className="text-sm text-slate-400">WhatsApp</p>
                <p className="font-medium text-slate-800">+91 70941 27906</p>
              </div>
            </a>

            <div className="flex items-center gap-4 p-5 rounded-2xl border border-slate-200">
              <div className="w-11 h-11 rounded-xl bg-pink-50 text-pink-600 flex items-center justify-center flex-shrink-0">
                <MapPin size={20} />
              </div>
              <div>
                <p className="text-sm text-slate-400">Location</p>
                <p className="font-medium text-slate-800">Pudukkottai, Tamil Nadu</p>
              </div>
            </div>
          </div>

          {/* Form */}
          <form
            onSubmit={handleSubmit}
            className="lg:col-span-3 rounded-2xl border border-slate-200 p-6 sm:p-8 space-y-5"
          >
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                Your Name
              </label>
              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:border-violet-400 focus:ring-2 focus:ring-violet-100 transition-all text-slate-800"
                placeholder="John Doe"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                Your Email
              </label>
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:border-violet-400 focus:ring-2 focus:ring-violet-100 transition-all text-slate-800"
                placeholder="john@example.com"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                Message
              </label>
              <textarea
                required
                rows={4}
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:border-violet-400 focus:ring-2 focus:ring-violet-100 transition-all resize-none text-slate-800"
                placeholder="Tell me about the opportunity or just say hi..."
              />
            </div>
            <button
              type="submit"
              className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-full font-semibold text-white bg-gradient-to-r from-violet-600 to-pink-600 hover:shadow-lg hover:shadow-violet-300 transition-all"
            >
              Send Message
              <Send size={16} />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}